<app-navbar></app-navbar>
<div class="content">
  <div class="page-header">
    <h2 itemprop="headline">
      HUIOSPAY TERMS AND CONDITIONS <br />
      <!-- Effective Date: September 2023 -->
    </h2>
  </div>
  <div itemprop="articleBody">
    <span style="color: #686868"
      ><b>WELCOME TO HUIOSPAY’S WEB PLATFORM / SERVICES.</b></span
    >

    <p>
      <b
        >Please read these terms and conditions carefully before using the
        Services.</b
      >
      By using the Services, you agree to be bound by these terms and
      conditions. This agreement contains the terms and conditions for the usage
      of this website. It is essential for users to read it, as it will affect
      relations between Huiospay and users. so read it carefully. <br /><br />
      Continuous usage will be construed as acceptance of the terms and
      conditions contained therein. <br /><br />
      These terms and conditions may be revised periodically and will take
      effect once updated on the site
    </p>

    <p style="text-align: justify" align="justify">
      <span style="color: #686868"><b>DEFINITIONS</b></span>
    </p>
    <p style="text-align: justify" align="justify">
      <span style="color: #646464">
        <b>"Content":</b> Any data, information, text, software, images, audio,
        video, or other materials that are posted, uploaded, transmitted, or
        otherwise made available through the Services. <br />

        <b>"User":</b> Any individual or entity that accesses or uses the
        Services. <br />

        <b>"You":</b> The User. <br />
      </span>
    </p>
    <p style="text-align: justify" align="justify">
      <span style="color: #686868"><b>ELIGIBILTY</b></span>
    </p>
    <p style="text-align: justify" align="justify">
      <span style="color: #646464">
        You must be at least 18 years of age and a resident of Nigeria to use
        the Services.
      </span>
    </p>

    <p style="text-align: justify" align="justify">
      <span style="color: #686868"><b>REGISTRATION</b></span>
    </p>
    <p style="text-align: justify" align="justify">
      <span style="color: #646464"
        >To use certain features of the Services, you may be required to
        register for an account. When registering for an account, you agree to
        provide accurate and complete information about yourself. You are
        responsible for maintaining the confidentiality of your account login
        information and for all activities that occur under your account. You
        agree to notify us immediately of any unauthorized use of your
        account.</span
      >
    </p>
    <p style="text-align: justify" align="justify">
      <span style="color: #686868"><b>ACCESSIBILITY </b></span>
    </p>
    <p style="text-align: justify" align="justify">
      <span style="color: #646464"
        >The website is freely accessible to all users although there might be
        limitations pending the creation of accounts and security/passwords
        before users can avail certain products and services. Users are
        responsible for providing equipment, technologies, or software which
        gain them access to the internet and our site. In other words, users
        will be liable for their internet fees/charges to their service
        provider.
      </span>
    </p>
    <!-- <p style="text-align: justify" align="justify">
      <b>Information you provide to us: </b>
      <span style="color: #646464"
        >We collect personal data that you provide to us when you create an
        account, use our Services, or contact us for customer support. This may
        include your name, address, phone number, email address, date of birth,
        and financial information.</span
      >
    </p> -->
    <!-- <p style="text-align: justify" align="justify">
      <b>Information we collect automatically: </b>
      <span style="color: #646464">
        We automatically collect certain non-personal data when you use our
        Services, such as your IP address, device type, browser type, and
        referring URL.</span
      >
    </p> -->
    <!-- <p style="text-align: justify" align="justify">
      <b>Information from third parties: </b>
      <span style="color: #646464">
        We may collect personal data about you from third parties, such as
        credit bureaus ,social media platform or other financial service
        providers and other related agencies.
      </span>
    </p> -->
    <!-- <p style="text-align: justify" align="justify">
      <b>Information collected manually: </b>
      <span style="color: #646464">
        we may collect customer’s data when they visit our physical locations
        for inquiries or enter data manually for our services and products. We
        may collect customers’ data through our customer services platforms
        which includes phone calls, emails, social media and other communication
        medium.
      </span>
    </p> -->

    <p style="text-align: justify" align="justify">
      <span style="color: #686868"><b>SECURITY </b></span>
    </p>
    <p style="text-align: justify" align="justify">
      <span style="color: #646464"
        >Transactions on this site are secured and for users to have full
        functionality/access to our products and services they need to create
        accounts with appropriate passwords. Users are responsible for the
        safety and security of their account details. And user account may be
        disabled due to security breaches, abuses, or failure to comply with
        terms and conditions.
      </span>
    </p>

    <p style="text-align: justify" align="justify"></p>
    <p style="text-align: justify" align="justify">
      <span style="color: #686868"><b>USER CONDUCT </b></span>
    </p>

    <p style="text-align: justify" align="justify">
      <span style="color: #646464"
        >The purpose of the Huiospay website/platform is to enable and complete
        various legal commercial transactions and users may be disabled for
        inappropriate or unlawful usage. To enjoy access to our
        website/platforms users must undertake to do the following:
      </span>
    </p>

    <ul style="text-align: justify">
      <li>
        <span style="color: #686868"
          >Use the website/platform for lawful purposes and transactions</span
        >
      </li>
      <li>
        <span style="color: #686868"
          >Avoid conduct deemed unlawful, abusive, libelous, threatening, and
          obscene or transmission of questionable materials with content that
          may infringe on the rights or sensibility of others.
        </span>
      </li>

      <li>
        <span style="color: #686868"
          >To keep to the theme of the site (commercial transactions)
        </span>
      </li>

      <li>
        <span style="color: #686868"
          >To ensure all information provided on the website is true and not
          false or misleading.
        </span>
      </li>
      <li>
        <span style="color: #686868"
          >Not post materials that may contain harmful soft wares or viruses.
        </span>
      </li>
      <li>
        <span style="color: #686868"
          >Not to violate any policy /guidelines of this website.
        </span>
      </li>
      <li>
        <span style="color: #686868"
          >Not to undertake any act or action that may disrupt normal
          services/flow of information and transactions on our website.
        </span>
      </li>
    </ul>

    <p style="text-align: justify" align="justify"></p>
    <p style="text-align: justify" align="justify">
      <span style="color: #686868"
        ><b>INTELLECTUAL PROPERTY/COPYRIGHT </b></span
      >
    </p>
    <p style="text-align: justify" align="justify">
      <span style="color: #686868">
        Huiospay is the registered trademark of Huios Finance Limited and the
        owner of the Intellectual property of Huiospay and its platforms.
        Materials published therein are the property of Huiospay and all
        unauthorized use may lead to legal action.
      </span>
    </p>

    <p style="text-align: justify" align="justify"></p>
    <p style="text-align: justify" align="justify">
      <span style="color: #686868"><b>THIRD -PARTY & LINKS </b></span>
    </p>
    <p style="text-align: justify" align="justify">
      <span style="color: #686868">
        The Services may contain links to third-party websites or services that
        are not owned or controlled by <b>HuiosPay.</b> We have no control over,
        and assume no responsibility for, the content, privacy policies, or
        practices of any third-party websites or services. You further
        acknowledge and agree that <b>HuiosPay</b> shall not be responsible or
        liable, directly or indirectly, for any damage or loss caused or alleged
        to be caused by or in connection with the use of or reliance on any such
        content, goods or services available on or through any such websites or
        services.
      </span>
    </p>

    <p style="text-align: justify" align="justify"></p>
    <p style="text-align: justify" align="justify">
      <span style="color: #686868"><b>DISCLAIMER WARRANTIES </b></span>
    </p>
    <p style="text-align: justify" align="justify">
      <span style="color: #686868">
        HuiosPay makes no warranties, express or implied, about the Services.
        The Services are provided "as is" and "as available". We disclaim all
        warranties of merchantability, fitness for a particular purpose, and
        non-infringement.
      </span>
    </p>

    <p style="text-align: justify" align="justify"></p>
    <p style="text-align: justify" align="justify">
      <span style="color: #686868"><b>LIABILITY </b></span>
    </p>
    <p style="text-align: justify" align="justify">
      <span style="color: #686868">
        Huiospay shall not be liable directly or indirectly, incidental or
        consequential for damages of any kind of losses as a result of:
      </span>
    </p>

    <ul style="text-align: justify">
      <li>
        <span style="color: #686868"
          >Unauthorized usage or access (hacking)
        </span>
      </li>
      <li>
        <span style="color: #686868"
          >Unauthorized statement or conduct by or attributed to users
        </span>
      </li>

      <li>
        <span style="color: #686868">Exigencies of business. </span>
      </li>
    </ul>

    <p style="text-align: justify" align="justify">
      <span style="color: #686868"><b>INDEMNIFICATION </b></span>
    </p>
    <p style="text-align: justify" align="justify">
      <span style="color: #646464">
        Users agree to indemnify Huiospay, its parent company, affiliates, and
        agents from any and all liabilities, claims, and expenses arising from
        breach of this Agreement except when caused by Huiospay’s intentional
        misconduct or gross negligence.
      </span>
    </p>

    <p style="text-align: justify" align="justify">
      <span style="color: #686868"><b>MISCELLANEOUS </b></span>
    </p>
    <p style="text-align: justify" align="justify">
      <span style="color: #646464">
        This agreement along with privacy services as the basis of the
        relationship between the users and Huiospay. This agreement is personal
        to the user and may not be assigned to anyone. <br />
        This agreement does not create any association, partnership, principal
        and agent, employee and employer, master and servant relation but rather
        independent parties.
      </span>
    </p>

    <p style="text-align: justify" align="justify">
      <span style="color: #686868"><b>FEE </b></span>
    </p>
    <p style="text-align: justify" align="justify">
      <span style="color: #646464">
        Upon enrolment on our sites, customers/users may be liable for such fees
        for certain services rendered. These may be monthly or otherwise
        depending on what services or product was used.
      </span>
    </p>

    <!-- <ul style="text-align: justify">
      <li>
        <span style="color: #686868"
          ><b>The right to access your personal data– </b> Customer have the
          right to request for copies of their personal data that we hold.
          HuiosPay may charge a fee for this service
        </span>
      </li>
      <li>
        <span style="color: #686868"
          ><b>The right to rectification of inaccurate personal data – </b>
          Customers have the right to: request that HuiosPay rectifies any
          information they believe and have proven have been captured
          inaccurately. Customers also have the right to request HuiosPay to
          complete the information they believe is incomplete.
        </span>
      </li>

      <li>
        <span style="color: #686868"
          ><b>The right to erasure of your personal data– </b> Customers have
          the right to: request that HuiosPay erases their personal data, under
          certain conditions. These conditions are not limited to regulatory
          requirements, law enforcement agencies, or where such action may cause
          disruption to our system.
        </span>
      </li>

      <li>
        <span style="color: #686868"
          ><b>The right to restrict processing of your personal data– </b>
          Customers have the right to: request that HuiosPay restricts the
          processing of their personal data, under certain conditions.
        </span>
      </li>

      <li>
        <span style="color: #686868"
          ><b>The right to object to processing of your personal data– </b>
          Customers have the right to object to HuiosPay processing of your
          personal data, under certain conditions.
        </span>
      </li>
      <li>
        <span style="color: #686868"
          ><b>The right to data portability – </b>
          Customers have the right to: request to receive your personal data
          that HuiosPay may have collected in a structured, commonly used, and
          machine-readable format and to have it transmitted to another
          controller/organization, or directly to them, under certain
          conditions.
        </span>
      </li>
    </ul> -->

    <p style="text-align: justify" align="justify">
      <span style="color: #686868"><b>TERMINATION</b></span>
    </p>
    <p style="text-align: justify" align="justify">
      <span style="color: #646464">
        We may terminate your use of the Services at any time without notice or
        liability. We may also terminate your use of the Services if you violate
        any of these terms and conditions.
      </span>
    </p>

    <p style="text-align: justify" align="justify">
      <span style="color: #686868"><b>CHANGES TO TERMS AND CONDITIONS</b></span>
    </p>
    <p style="text-align: justify" align="justify">
      <span style="color: #646464">
        We may update these terms and conditions from time to time. We will
        notify you of any material changes by posting the updated terms and
        conditions on our website. You are responsible for reviewing
      </span>
    </p>

    <p style="text-align: justify" align="justify">
      <span style="color: #686868"><b>GOVERNING LAW </b></span>
    </p>
    <p style="text-align: justify" align="justify">
      <span style="color: #646464">
        The Laws of the Federal Republic of Nigeria shall govern this Agreement.
        The Nigerian courts have jurisdiction in relation to any dispute or
        claim arising out of or in connection with the terms or their subject
        matter or formation.
      </span>
    </p>

    <!-- <p style="text-align: justify" align="justify">
      <span style="color: #686868"><b>Data Security</b></span>
    </p>
    <p style="text-align: justify" align="justify">
      <span style="color: #646464">
        We have implemented appropriate security measures to protect your
        personal data from unauthorized access, use, disclosure, alteration, or
        destruction. These measures include:
      </span>
    </p> -->

    <!-- <ul style="text-align: justify">
      <li>
        <span style="color: #686868"
          ><b>Physical security measures: </b> We have implemented physical
          security measures to protect our data centres, including access
          control systems and security cameras.</span
        >
      </li>
      <li>
        <span style="color: #686868"
          ><b>Technical security measures: </b>We have implemented technical
          security measures to protect our data, such as encryption and
          firewalls.
        </span>
      </li>

      <li>
        <span style="color: #686868"
          ><b>Organizational security measures: </b> We have implemented
          organizational security measures to protect our data, such as data
          breach reporting procedures and employee training.
        </span>
      </li>
    </ul> -->


    <p align="justify" style="margin-bottom: 100px">
      <!-- <span style="color: #686868"
        >If you have concerns or any questions about this Privacy Policy,and
        would like to exercise your protection rights;<br />
        Please contact us at
        <a href="mailto:contactus@huiospay.com">contactus@huiospay.com</a> or
        <a href="mailto:privacy@huiospay.com">privacy@huiospay.com</a>.<br />
        Our Customer Contact Centre :+234(0) 8037086670 |(0) 8096247247 <br />
        &COPY;2023 HuiosPay
      </span> -->
    </p>
  </div>
</div>
<app-footer></app-footer>
